package ru.education.building.schedule.data.models

import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse(
    val data: List<Misis>
)

@Serializable
data class ApiResponseGroup(
    val data: List<MisisGroups>
)

@Serializable
data class MisisGroups(
    val id: String,
    val name: String
)

@Serializable
data class Misis(
    val date: String,
    val day_num: Int,
    val time_start: String,
    val time_end: String,
    val subject: String?,
    val type: String,
    val teacher: String?,
    val room: String,
)